export const BrandList = [
  'アイチ',
  'アウディ',
  'アウトウニオン',
  'アウトビアンキ',
  'アストンマーティン',
  'アバルト',
  'アルピーヌ',
  'アルファロメオ',
  'アロー',
  'アングリア',
  'アンチコ',
  'いすゞ',
  'いすゞフルハーフ',
  'イノセンティ　ミニ',
  'イノチェンティ',
  'インペリアル',
  'ウイリス',
  'ウズレー',
  'ウニモグ',
  'エスコ',
  'エスコート',
  'オオタ',
  'オペル',
  'オースチン',
  'オースチンヒーレー',
  'オーストラリア三菱',
  'オーテック　ザガート',
  'オールズモビル',
  'カプリ',
  'カーボディーズ',
  '起亜',
  'キャデラック',
  'キャラベルエア',
  'クボタ',
  'クライスラー',
  'くろがね',
  'コンサル',
  'ゴリアット',
  'サカイ',
  'サターン',
  'サンダーバード',
  'サンビーム',
  'サンヨン',
  'サーブ',
  'シトロエン',
  'シボレー',
  'シムカ',
  'シンガー',
  'ジェンセン',
  'ジャイアント',
  'ジャガー',
  'ジャベリン',
  'ジュピタージュニア',
  'ジープ',
  'スズキ',
  'スター',
  'スバル',
  '住友',
  '住友ハノマーグ',
  'タカキタ',
  'タルボ',
  'ダイナパック',
  'ダイハツ',
  'ダイムラー',
  'ダッジ',
  'ダッジダート',
  'ダットサン',
  'テスラ',
  'デトマソ',
  'デリカ',
  'デーウ',
  'トヨタ',
  'トヨタ　ＴＭＭ',
  'トヨタ　ＴＭＭＫ',
  'トヨペット',
  'トライアンフ',
  'ニイガタ',
  '日産',
  '日産ジュニア',
  '日産ディーゼル',
  '日産ＭＩ',
  '日産ＭＴ',
  '日産ＮＭ',
  '日産ＵＫ',
  '日車',
  '日本フォード',
  'ネッカー',
  'ハマナ',
  'ハマー',
  'ハンバー',
  'バリアント',
  'パナール',
  'パブリカ',
  'パンサー',
  'ヒュンダイ',
  'ヒルマン',
  'ヒルマンインプ',
  'ヒルマンミンクス',
  '日野',
  '日野ルノー',
  'ビュイック',
  'ピニンファリナ',
  'フィアット',
  'フェラーリ',
  'フォルクスワーゲン',
  'フォード',
  'フォードサンダーバード',
  'フォードファルコン',
  'フォードムスタング',
  'フォード（タウナス）',
  'フランスベッド',
  'ブガッティ',
  'プジョー',
  'プリムス',
  'プリンス',
  'プリンセス',
  'プロトン',
  'ベルトーネ',
  'ベントレー',
  'ホクサツ',
  'ホッタ',
  'ホドガヤ',
  'ホンダ',
  'ホンダオブアメリカ',
  'ホンダオブザユーケー',
  'ホンダカナダ',
  'ホンダドリーム',
  'ホールデン',
  'ボクスホール',
  'ボルボ',
  'ポルシェ',
  'ポンテアック',
  'マイバッハ',
  'マクラーレン',
  'マセラティ',
  'マツダ',
  'マツダＮＭ',
  'マーキュリー',
  '三井',
  '三井三池',
  'ミツオカ',
  '三菱',
  '三菱ユンボ',
  '三菱（ダイヤモンドスター）',
  'ミニ',
  'ムスタング',
  'メイワ',
  'メルセデス・ベンツ',
  'モンテゴ',
  'モーガン',
  'モーク',
  'モーリス',
  'ヤンマー',
  'ユーノス',
  'ライレー',
  'ラビット',
  'ランチア',
  'ランドローバー',
  'ランブラー',
  'ランボルギーニ',
  'ラーダ',
  'リライアント',
  'リンカーン',
  'ルノー',
  'レクサス',
  'ランドローバー',
  'ロータス',
  'ローバー',
  'ロールスロイス',
  'ＡＭＣ',
  'ＡＳＡ',
  'ＢＭＷ',
  'ＢＭＷアルピナ',
  'ＣＴ＆Ｔ',
  'ＤＫＷ',
  'ＧＭダット',
  'ＧＭＣ',
  'ＭＣＣ',
  'ＭＧ',
  'ＮＳＵ',
  'ＮＵＭＭＩ',
  'ＴＣＭ',
  'ＴＭＵＫ',
  'ＴＶＲ',
  'ＵＤトラックス',
  'ＶＷポルシェ',
  '旭',
  '石川島コーリング',
  '神鋼　Ｐ＆Ｈ',
  '豊和',
  '陸王',
  'その他',
]
